import { render } from "./client-branch.vue?vue&type=template&id=4e804ce8&scoped=true&ts=true"
import script from "./client-branch.vue?vue&type=script&lang=ts"
export * from "./client-branch.vue?vue&type=script&lang=ts"

import "./client-branch.vue?vue&type=style&index=0&id=4e804ce8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e804ce8"]])

export default __exports__